// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./navbar.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!./home.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js!./footer.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../node_modules/css-loader/dist/cjs.js!./gallery.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../node_modules/css-loader/dist/cjs.js!./news.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../node_modules/css-loader/dist/cjs.js!./market.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../node_modules/css-loader/dist/cjs.js!./profile.css";
import ___CSS_LOADER_AT_RULE_IMPORT_7___ from "-!../../node_modules/css-loader/dist/cjs.js!./product.css";
import ___CSS_LOADER_AT_RULE_IMPORT_8___ from "-!../../node_modules/css-loader/dist/cjs.js!./newsdetail.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_7___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Poppins", sans-serif;
}

:root {
  scroll-behavior: smooth;
}

.main-content-wrapper {
  min-height: 100vh;
}

.loading-circle-container {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  justify-content: center;
  align-items: center;
  z-index: 99999;
}

.loading-circle {
  width: 50px;
  height: 50px;
  border: 10px solid #327a6d;
  border-radius: 50%;
  border-top: 10px solid #fff;
  animation: spin 1s linear infinite;
}

.lazyload {
  opacity: 0;
  transition: opacity 0.5s;
}
.lazyloaded {
  opacity: 1;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.go-to-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #327a6d;
  color: white;
  border: none;
  border-radius: 10px;
  width: 50px;
  height: 50px;
  font-size: 25px;
  display: none;
  cursor: pointer;
  text-align: center;
  line-height: 50px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.go-to-top:hover {
  background-color: #255e49;
}

.go-to-top:focus {
  outline: none;
}

@media (max-width: 580px) {
  .go-to-top {
    width: 35px;
    height: 35px;
    font-size: 22px;
    line-height: 0;
    border-radius: 5px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAWA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc;IACd,kBAAkB;EACpB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\r\n@import \"navbar.css\";\r\n@import \"home.css\";\r\n@import \"footer.css\";\r\n@import \"gallery.css\";\r\n@import \"news.css\";\r\n@import \"market.css\";\r\n@import \"profile.css\";\r\n@import \"product.css\";\r\n@import \"newsdetail.css\";\r\n\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n  font-family: \"Poppins\", sans-serif;\r\n}\r\n\r\n:root {\r\n  scroll-behavior: smooth;\r\n}\r\n\r\n.main-content-wrapper {\r\n  min-height: 100vh;\r\n}\r\n\r\n.loading-circle-container {\r\n  display: none;\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: #fff;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 99999;\r\n}\r\n\r\n.loading-circle {\r\n  width: 50px;\r\n  height: 50px;\r\n  border: 10px solid #327a6d;\r\n  border-radius: 50%;\r\n  border-top: 10px solid #fff;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n.lazyload {\r\n  opacity: 0;\r\n  transition: opacity 0.5s;\r\n}\r\n.lazyloaded {\r\n  opacity: 1;\r\n}\r\n\r\n@keyframes spin {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.go-to-top {\r\n  position: fixed;\r\n  bottom: 20px;\r\n  right: 20px;\r\n  background-color: #327a6d;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 10px;\r\n  width: 50px;\r\n  height: 50px;\r\n  font-size: 25px;\r\n  display: none;\r\n  cursor: pointer;\r\n  text-align: center;\r\n  line-height: 50px;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.go-to-top:hover {\r\n  background-color: #255e49;\r\n}\r\n\r\n.go-to-top:focus {\r\n  outline: none;\r\n}\r\n\r\n@media (max-width: 580px) {\r\n  .go-to-top {\r\n    width: 35px;\r\n    height: 35px;\r\n    font-size: 22px;\r\n    line-height: 0;\r\n    border-radius: 5px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
